<template>
  <a :href="baseUrl() + item.link" :data-testid="`sbx-pcc_mSubCatV4-link-${index}`" :title="item.label" class="mSubCat4__link">
    <img v-bind:src="propsByScreenSize" class="mSubCatV4__image" :alt="item.label" :data-testid="`sbx-pcc_mSubCatV4-image-${index}`" />
    <h3 class="mSubCat4__item-label">{{ item.label }}</h3>
  </a>
</template>

<script>
import { baseUrl } from '@/SharedFe/utils/urlUtils';

export default {
  name: 'merchSubCategoryV4Base',
  props: ['item', 'index', 'screenSize'],
  data() {
    return {
      baseUrl,
    };
  },
  computed: {
    propsByScreenSize() {
      const image = Object.keys(this.item.images).includes(this.screenSize) ? this.item.images[this.screenSize] : this.item.images.base;
      return image;
    },
  },
};
</script>
